<template>
  <div class="template-message-component">
    <vs-row class="flex justify-center items-center">
      <div class="mb-8 flex justify-center items-center items-card pl-4 pr-4">
        <div class="vx-col w-full mb-2">
          <div class="w-full flex justify-center items-center pt-4 pb-4">
            <div class="w-6/12 flex justify-center items-center" style="flex-direction: column;">
              <div class="w-full flex justify-start items-start">
                <span class="card-title ml-2">Cabeçalho</span>
                <vs-chip
                    color="info text-black"
                    class="ml-2"
                >Opcional</vs-chip>
              </div>
              <div class="w-full flex justify-start items-start">
                <span class="card-subtitle">Adicione um título ou escolha qual tipo de mídia você usará para esse cabeçalho.</span>
              </div>

              <vs-input
                  name="header"
                  class="w-full"
                  maxlength="60"
                  v-validate="'no-emoji'"
                  v-model="data.headerText"
                  placeholder="Insira o texto em Português (BR)"
              />

              <div class="w-full params-wrapper mt-5" v-if="data.headerText">
                <span class="text-sm">Caracteres: {{data.headerText.length}}/60</span>
              </div>

              <vs-alert color="danger" icon="new_releases" active="true" class="mt-3 text-sm" v-show="errors.has('header')">
                <p>Não é permitido o uso de emoji nesse campo.</p>
              </vs-alert>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-8 flex justify-center items-center items-card pl-4 pr-4">
        <div class="vx-col w-full mb-2">
          <div class="w-full flex justify-center items-center pt-4 pb-4">
            <div class="w-6/12 flex justify-center items-center" style="flex-direction: column;">
              <div class="w-full flex justify-start items-start">
                <span class="card-title ml-2">Corpo</span>
              </div>
              <div class="w-full flex justify-start items-start">
                <span class="card-subtitle">Insira o texto da sua mensagem em português (BR).</span>
              </div>

              <textarea
                  class="vs-textarea text-area message-text-area "
                  v-model="data.bodyText"
                  ref="meta-message-body"
                  maxlength="1024"
                  style=" resize: vertical !important;"
                  placeholder="Insira o texto em Português (BR)"
                  @mouseup="isFormatted"
              />

              <div class="w-full params-wrapper mt-5 flex flex-wrap items-center justify-between">
                  <span style="font-size: 10px;">Caracteres: {{data.bodyText.length}}/1024</span>      
                <div class="flex items-center" id="styleComponents">
                  <vs-icon class="mr-2 border-button-format" type="border" color="primary"  @click.prevent="toggleFormat('*')" icon="format_bold" />
                  <vs-icon class="mr-2 border-button-format" type="border" color="primary" @click.prevent="toggleFormat('_')" icon="format_italic" />
                  <vs-icon class="mr-2 border-button-format" type="border" color="primary" @click.prevent="toggleFormat('~')" icon="strikethrough_s" />
                  <vs-icon class="mr-2 border-button-format" type="border" color="primary" @click.prevent="toggleFormat('```')" icon="code" />
                  <vs-button
                      type="border"
                      color="primary"
                      class="float-right"
                      id="formatButton"
                      @click.prevent="insertTagOnText()"
                  >
                    + Adicionar variável
                  </vs-button>
                </div>
              </div>

              <vs-alert color="danger" icon="new_releases" active="true" class="mt-3 text-sm" v-if="showError">
                <p>O texto do corpo contém parâmetros de variável no início ou no fim. Você precisa alterar esse formato.</p>
                <a href="https://developers.facebook.com/docs/whatsapp/message-templates/guidelines/" class="text-sm">
                  Saiba mais sobre formatação nas nossas Diretrizes de modelo de mensagem
                </a>
              </vs-alert>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-8 flex justify-center items-center items-card pl-4 pr-4">
        <div class="vx-col w-full mb-2">
          <div class="w-full flex justify-center items-center pt-4 pb-4">
            <div class="w-6/12 flex justify-center items-center" style="flex-direction: column;">
              <div class="w-full flex justify-start items-start">
                <span class="card-title ml-2">Rodapé</span>
                <vs-chip
                    color="info text-black"
                    class="ml-2"
                >Opcional</vs-chip>
              </div>
              <div class="w-full flex justify-start items-start">
                <span class="card-subtitle">Adicione uma pequena linha de texto na parte inferior do seu modelo de mensagem.</span>
              </div>

              <vs-input
                  name="footer"
                  class="w-full"
                  maxlength="60"
                  v-validate="'no-emoji'"
                  v-model="data.footerText"
                  placeholder="Insira o texto em Português (BR)"
              />

              <div class="w-full params-wrapper mt-5" v-if="data.footerText">
                <span class="text-sm">Caracteres: {{data.footerText.length}}/60</span>
              </div>

              <vs-alert color="danger" icon="new_releases" active="true" class="mt-3 text-sm" v-show="errors.has('footer')">
                <p>Não é permitido o uso de emoji nesse campo.</p>
              </vs-alert>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-8 flex justify-center items-center items-card pl-4 pr-4">
        <div class="vx-col w-full mb-2">
          <div class="w-full flex justify-center items-center pt-4 pb-4">
            <div class="w-6/12 flex justify-center items-center" style="flex-direction: column;">
              <div class="w-full flex justify-start items-start">
                <span class="card-title ml-2">Botões</span>
                <vs-chip
                    color="info text-black"
                    class="ml-2"
                >Opcional</vs-chip>
              </div>
              <div class="w-full flex justify-start items-start">
                <span class="card-subtitle">Crie botões que permitem que os clientes respondam à sua mensagem ou executem uma ação.</span>
              </div>

              <v-select
                  autocomplete
                  label="text"
                  class="w-full"
                  id="input-button"
                  :options="data.buttonType"
                  v-model="selectedButton"
                  @input="resetItems"
              ></v-select>

              <div class="w-full" v-if="selectedButton && selectedButton.value === 'QUICK_REPLY'" >
                <div class="mb-8 flex w-full justify-center items-center items-card pl-3 pr-3 mt-5">
                  <div class="w-full flex justify-center items-center pt-3 pb-3">
                    <div class="w-full flex justify-center items-center" style="flex-direction: column;">
                      <div class="w-full">
                        <div v-if="items.length > 3" class="card-subtitle m-1 text-center">
                          <small style="font-size: 11px;">Acima de 3 botões será convertido em lista automaticamente.</small>
                        </div>
                        <draggable group="buttons" v-model="itemsCopy">
                          <div class="w-full flex justify-center"  v-for="(item, index) in items" :key="item.key">
                            <feather-icon 
                              icon='ListIcon' 
                              svgClasses='h-6 w-6' 
                              class='ml-2 cursor-pointer' 
                              style="margin-right: 20px;" 
                              :style="hasError('button'+index) ? 'margin-bottom:35px' : 'margin-bottom:0px'"
                            />

                            <div 
                              style="background-color: rgb(240, 240, 240); border-radius: 10px; width: 450px; height: 100px; margin-top: 15px;"
                              :style="hasError('button'+index) ? 'margin-bottom: 57px' : 'margin-bottom: 20px'"
                              >
                              <component
                                  style="margin-left: 25px; margin-top: 10px; margin-right: 20px;"
                                  :is="item"
                                  :key="index"
                                  :index="index"
                                  :item="itemsCopy[index]"
                                  :componentName="'button'+index"
                                  :lengthMax="25"
                                  :identifier="null"
                                  :validateCustom="'no-emoji'"
                                  :ableToRemove="itemsCopy.length > 1"
                                  @onRemoveReasonOptionItem="removeItem"
                              />

                              <vs-alert color="danger" icon="new_releases" active="true" class="mb-2 mt-4 text-sm" v-show="hasError('button'+index)">
                                <p>Não é permitido o uso de emoji nesse campo.</p>
                              </vs-alert>
                            </div>
                          </div>
                        </draggable>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="w-full params-wrapper mt-5">
                  <vs-button
                  style="margin-bottom: 20px;"
                      type="border"
                      color="primary"
                      class="float-right"
                      id="formatButton"
                      @click.prevent="addItem()"
                  >
                    + Adicionar botão
                  </vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-8 flex justify-center items-center items-card pl-4 pr-4">
        <div class="vx-col w-full mb-2">
          <div class="w-full flex justify-center items-center pt-4 pb-4">
            <div class="w-6/12 flex justify-center items-center" style="flex-direction: column;">
              <div class="w-full flex justify-start items-start">
                <span class="card-title ml-2">Adicionar exemplo de conteúdo</span>
                <vs-chip
                    color="primary text-white"
                    class="ml-2"
                >Obrigatório</vs-chip>
              </div>
              <div class="w-full flex justify-start items-start">
                <span class="card-subtitle">
                  Para nos ajudar a entender o tipo de mensagem que deseja enviar, você tem a opção de fornecer
                  exemplos de conteúdo específicos para seu modelo. Você pode adicionar um exemplo de modelo para um ou
                  todos os idiomas que enviará.Lembre-se de incluir qualquer informação real do usuário ou do cliente,
                  e forneça apenas conteúdo de amostra nos seus exemplos.
                  <a href="https://developers.facebook.com/docs/whatsapp/message-templates/guidelines">Saiba mais</a>
                </span>
              </div>

              <div v-for="(example, index) in data.variableExamples" :key="index" class="w-full">
                <vs-input
                    class="w-full mt-3"
                    v-model="example.value"
                    :placeholder="'Insira o conteúdo para {{' + (index + 1) + '}}'"
                    v-validate="'required'"
                />
              </div>

              <vs-alert color="danger" icon="new_releases" active="true" class="mt-3 text-sm" v-if="showAlert">
                <p>Será necessário o preenchimento da variável para prosseguir com a criação do modelo de mensagem.</p>
                <a href="https://developers.facebook.com/docs/whatsapp/message-templates/guidelines/" class="text-sm">
                  Saiba mais sobre formatação nas nossas Diretrizes de modelo de mensagem
                </a>
              </vs-alert>
              

              <vs-card class="mt-5">
                <div slot="header">
                  <span class="card-title ml-2">Prévia da Mensagem</span>
                </div>
                <div style="font-size: 13px;">
                  <div class="message-bubble">
                    <strong v-if="data.headerText !== null">{{ data.headerText }}</strong>
                    <p v-html="formattedBodyMessageComputed"></p>
                    <small v-if="data.footerText !== null">{{ data.footerText }}</small>

                    <div v-if="data.buttons.length" class="w-full buttons">
                      <div v-for="(item, index) in data.buttons.slice(0, 3)" :key="index">
                        <vs-chip v-if="index === 2 && data.buttons.length > 3">
                          <vs-icon icon="menu" size="small" /> Veja mais opções
                        </vs-chip>
                        <vs-chip v-else>{{ item.description }}</vs-chip>
                      </div>
                    </div>
                  </div>

                  <div style="clear: both;"></div>
                </div>
              </vs-card>
            </div>
          </div>
        </div>
      </div>

      <div class="meta-template-message-container-width">
        <vs-button
            color="primary"
            type="filled"
            @click.prevent="$emit('previousPage')"
        >
          <span>Voltar</span>
        </vs-button>

        <vs-button
            color="primary"
            type="filled"
            class="float-right"
            @click.prevent="add"
        >
          <span>Adicionar</span>
        </vs-button>
      </div>
    </vs-row>
  </div>
</template>

<script>

import draggable from 'vuedraggable'
import vSelect from 'vue-select'
import ReasonOptionItem from '@/views/reason-options/Item'

export default {
  name: 'meta-template-messages-wizard-configuration',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      items: [],
      variablesCount: 0,
      headerText: '',
      footerText: '',
      showError: false,
      showAlert: false,
      selectedButton: null,
      formattedBodyMessage: '',
      itemsCopy: [],
      formattedMessage: '',
    }
  },
  provide() {
    return {
      $validator: this.$validator
    }
  },
  watch: {
    "data.variableExamples": {
      handler() {
        this.updateFormattedMessage();
      },
      deep: true,
    },
    'data.bodyText'(val) {
      this.showError = this.data.bodyText.trim().startsWith('{{') || this.data.bodyText.trim().endsWith('}}');
      this.showAlert = this.data.bodyText.trim().indexOf('{{') !== -1
      const splittedText = val.split('{{')
      if (splittedText && splittedText.length > 1) {
        const lastNumber = (splittedText[splittedText.length - 1]).replace('}}', '')
        this.variablesCount = parseInt(lastNumber)
        let variableExamplesLength = this.data.variableExamples.length
        if (this.variablesCount < variableExamplesLength) {
          for (let count = 0; count < (variableExamplesLength - this.variablesCount); count++) {
            this.data.variableExamples.pop()
          }

          return this.updateFormattedMessage();
        }

        for (let count = 0; count < (this.variablesCount - variableExamplesLength); count++) {
          this.data.variableExamples.push({
            value: ''
          })
        }

        return this.updateFormattedMessage();
      }

      this.variablesCount = 0
      this.data.variableExamples = []
      this.formattedBodyMessage = this.data.bodyText
      return this.updateFormattedMessage();
    },
    selectedButton(val){
      if ( !val ) {
        this.items.forEach((item, index) => {
          this.removeItem(index)
        })
      }
    }
  },
  computed: {
    formattedBodyMessageComputed() {
      return this.formatText(this.formattedMessage);
    },
  },
  methods: {
    toggleFormat(marker) {
      const textarea = this.$refs['meta-message-body'];
      const selectedText = textarea.value.substring(textarea.selectionStart, textarea.selectionEnd);
      if (selectedText) {
        if (!this.isFormatted(marker)) {
          const newText = marker + selectedText + marker;
          this.data.bodyText = this.data.bodyText.substring(0, textarea.selectionStart) + newText + this.data.bodyText.substring(textarea.selectionEnd);
        } else {
          this.data.bodyText = this.data.bodyText.replace(new RegExp(marker, 'g'), '');
        }
      }
    },
    replacePlaceholder(text, example, index) {
      return example ? text.replace(`{{${index}}}`, example) : text;
    },
    isFormatted(marker) {
      const textarea = this.$refs['meta-message-body'];
      const selectedText = textarea.value.substring(textarea.selectionStart, textarea.selectionEnd);
      return selectedText.startsWith(marker) && selectedText.endsWith(marker);
    },
    async isValid() {
      return this.$validator.validateAll().then((valid) => { return valid && !this.errors.items.length }).catch((error) => { console.error(error) })
    },
    hasError(fieldName) {
      return this.errors.items ? this.errors.items.some(error => error.field === fieldName) : false
    },
    updateFormattedMessage() {
      this.formattedMessage = this.data.bodyText;
      this.data.variableExamples.forEach((example, index) => {
        this.formattedMessage = this.replacePlaceholder(
          this.formattedMessage,
          example.value,
          index + 1
        );
      });
    },
    formatText(text) {
      return text
        .replace(/\*(.*?)\*/g, '<strong>$1</strong>')
        .replace(/\_(.*?)\_/g, '<em>$1</em>')
        .replace(/~(.*?)~/g, '<del style="text-decoration: line-through;">$1</del>')
        .replace(/```(.*?)```/g, '<code style="font-family: monospace;">$1</code>');
    },
    loadItems() {
      this.data.buttonType.forEach((item) => {
        if ( item.selected ) {
          this.selectedButton = item
        }
      })

      this.data.buttons.forEach(() => {
        this.items.push(ReasonOptionItem)
      })
    },
    resetItems () {
      this.data.buttonType.forEach((item, index) => {
        this.data.buttonType[index].selected = !!(this.selectedButton && this.selectedButton.value === item.value)
      })

      this.items.forEach((item, index) => {
        this.removeItem(index)
      })

      if (this.items.length === 0) {
        this.addItem()
      }
    },
    addItem () {
      const newItem = { description: '' };
      this.data.buttons.push(newItem);
      const originalItemIndex = this.data.buttons.length - 1;
      this.itemsCopy.splice(originalItemIndex, 0, newItem);
      this.items.splice(originalItemIndex, 0, ReasonOptionItem);
    },
    removeItem (idx) {
      this.itemsCopy.splice(idx, 1)
      this.items.splice(idx, 1)
    },
    async add() {
      this.data.buttons = [...this.itemsCopy];
      if (await this.isValid()) {
        if (!this.data.bodyText) {
          this.$vs.notify({
            title: 'Revise os campos',
            text: 'É necessário preencher ao menos o corpo da mensagem para prosseguir!',
            color: 'danger'
          })
          return
        }
        this.$emit('add')
      }
    },
    insertTagOnText() {
      const that = this
      let tArea = this.$refs['meta-message-body']

      // get cursor's position:
      let startPos = tArea.selectionStart
      let endPos = tArea.selectionEnd
      let cursorPos = startPos
      let tmpStr = tArea.value || ''

      that.data.bodyText = `${tmpStr.substring(0, startPos)}{{${this.variablesCount+1}}}` +
          `${tmpStr.substring(endPos, tmpStr.length)}`

      // move cursor:
      setTimeout(() => {
        cursorPos += that.data.bodyText.length
        tArea.selectionStart = tArea.selectionEnd = cursorPos
        that.$refs['meta-message-body'].focus()
      }, 10)
    }
  },
  mounted(){
    this.loadItems()
    this.updateFormattedMessage();
    this.formattedBodyMessage = this.data.bodyText ? this.data.bodyText : '';
    this.items = [...this.itemsCopy];
  },
  created() {
    this.$validator.extend(
      'no-emoji',{
        getMessage: field =>  field + ' cannot contain emojis.',
        validate: (value) => {
          const emojiPattern = /([^-\p{L}\x00-\x7F]+)/u;
          return !emojiPattern.test(value);
        }
    });
  },
  components: {
    vSelect,
    ReasonOptionItem,
    draggable
  }
}
</script>

<style lang="scss">
.meta-template-message-container-width {
  width: 70%;
}

.template-message-component {
  .message-text-area {
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }

  .text-area {
    background: #fff;
    height: 100px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    resize: none !important;
  }

  .message-bubble {
    float: right;
    clear: both;
    padding: 10px;
    max-width: 88%;
    text-align: right;
    background: #DBF6C5;
    border-radius: .4em;
    word-wrap: break-word;
    border-bottom: 2px solid rgba(0,0,0,.3);

    > p {
      padding: 0 2px !important;
    }

    .buttons {
      padding: 0.5vw;
      margin-top: 1vw;
      border-radius: 1vw;
      display: inline-grid;
      justify-content: center;

      .vs-icon{
        font-size: 0.7rem;
        padding-top: 0.5rem;;
      }

      .con-vs-chip {
        cursor: pointer;
        width: 100% !important;
        &:hover{
          background-color: rgba(var(--vs-primary), 0.2) !important;
        }
      }
    }
  }

  .message-bubble:not(:last-child) {
    margin-bottom: 10px;
  }

  .message-bubble-answer {
    background-color: #eee;
    float: left;

    > p {
      text-align: left;
    }
  }
}

.items-card {
  width: 70%;
  background: #fff;
  margin-top: 5px;
  border: solid 1px rgba(0, 0, 0, 0.2);
  border-radius: 9px;
}

.card-title {
  font-weight: bold;
}

.card-option {
  font-weight: normal;
  font-size: .9rem;
}

.card-option-sub {
  font-weight: normal;
  font-size: .8rem;
}

.card-subtitle {
  font-size: .7rem;
  cursor: text;
  transition: all .2s ease;
  border-radius: 5px;
  padding: .7rem .7rem .7rem .5rem !important;
  color: rgba(0,0,0,.4);
}

#input-button {
  input.vs__search{
    color: #FFFFFF;
  }
}
#styleComponents{
  cursor: pointer;
  margin-left: 1px;
}
.border-button-format {
  border: 1px solid #1b9bff !important;
  padding: 0px !important;
  border-radius: 6px !important;
  transition: border-color 0.3s !important;
  width: 26px !important;
  height: 28px !important;
}
.border-button-format:hover {
  background-color: #ebf6ff
}
#formatButton{
  font-weight: bold;
}
</style>
